var staticParseInt = parseInt

module.exports = staticParseInt
